<template>
    <b-modal v-if="!loading" id="product_brand_form" ref="product_brand_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add Product Brand' : 'Edit Product Brand' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group class="mb-4">
                        <b-form-file v-model="image" placeholder="Choose a picture..."/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Description" class="has-float-label">
                        <b-form-textarea v-model="form.description" rows="6" placeholder="Description"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('product_brand_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitProductBrand">Submit</state-button>

            <state-button v-else variant="primary" :click="updateProductBrand">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ProductBrandFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit'
        ],

        data() {
            return {
                loading: true,
                image: null,
            }

        },

        computed: {
            ...mapGetters({
                form: 'getProductBrandForm',
                errors: 'getProductBrandErrors'
            })
        },

        mounted() {
            this.loading = false;
        },

        methods: {
            resetForm() {
                this.$store.commit('setProductBrandForm');
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            submitProductBrand() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitProductBrand', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new brand!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_brand_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateProductBrand() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateProductBrand', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the product brand!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_brand_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            }
        }

    }
</script>

<style scoped>

</style>
